import React from 'react';
import PromptEdit from './PromptEdit';

const MODEL_CONFIG = [
  {
    key: 'google-gemini-3-pro-image-preview',
    id: 'gemini-3-pro',
    property: 'Google Gemini 3 Pro Image Preview',
    limit: 9000,
    placeholder: 'Enter prompt for Google Gemini 3 Pro Image Preview',
  },
  {
    key: 'replicate-bytedance-seedream-5-lite',
    id: 'seedream-5-lite',
    property: 'Replicate Bytedance Seedream 5 Lite',
    limit: 2000,
    placeholder: 'Enter prompt for Replicate Bytedance Seedream 5 Lite',
  },
  {
    key: 'replicate-google-gemini-3-pro-image-preview',
    id: 'replicate-gemini',
    property: 'Replicate Google Gemini 3 Pro Image Preview',
    limit: 9000,
    placeholder: 'Enter prompt for Replicate Google Gemini 3 Pro Image Preview',
  },
];

const DEFAULT_MODELS = MODEL_CONFIG.reduce((acc, { key }) => ({ ...acc, [key]: '' }), {});

const ModelPrompts = ({ value = DEFAULT_MODELS, onChange }) => (
  <div className="mb-3">
    <h6>AI Models & Prompts</h6>
    {MODEL_CONFIG.map(({
      key,
      id,
      property,
      limit,
      placeholder,
    }) => (
      <PromptEdit
        key={key}
        id={id}
        property={property}
        value={value[key] ?? ''}
        limit={limit}
        placeholder={placeholder}
        onChange={(prompt) => onChange({ ...value, [key]: prompt })}
      />
    ))}
  </div>
);

export default ModelPrompts;
export { DEFAULT_MODELS };
